import { useContext } from 'react'
import { ToastContext } from '../context/ToastProvider'

const useToastNotification = () => {
    return useContext(ToastContext)
}

export default useToastNotification